import { DownlossTypeCode } from '../../quote-or-design-form/rooms/heatLoss/downlossTypeCode';
import { UnitFloorElementFormModel } from '../../quote-or-design-form/units/heatLoss/unitFloorElementFormModel';

export type UnitFloorElementResponse = {
  floorElementId: number;
  displayIndex: number;
  name: string;
  floorThermalTransmittance: number | null;
  downlossTypeCode: DownlossTypeCode;
  defaultTemperatureBelowInDegreesCelsius: number | null;
};

export const mapUnitFloorElementResponseToFormModel = (
  response: UnitFloorElementResponse,
): UnitFloorElementFormModel => ({
  floorElementId: response.floorElementId,
  name: response.name,
  floorThermalTransmittance: response.floorThermalTransmittance?.toString() ?? '',
  downlossTypeCode: response.downlossTypeCode,
  defaultTemperatureBelowInDegreesCelsius: response.defaultTemperatureBelowInDegreesCelsius?.toString() ?? '',
});
